'use strict';

var PayslipView = require('commons/views/Payslip');
var template    = require('../../templates/employee/Payslip.ejs');

module.exports = Backbone.View.extend({
    tabName:   'div',
    className: 'ibox-content',

    events: {
        'click .js-back-link': 'back'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            payslip:          null,
            itemYearlyTotals: null,
            payslipDetails:   null,
            companyLocation:  null
        });

        return this.render();
    },

    back: function() {
        window.history.back();
        return this;
    },

    render: function() {
        this.$el.html(template({}));

        this.view = new PayslipView(this.options);

        this.$el.append(this.view.el);

        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/Payslip.js